module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens4-a87e1e5c3c6d300d54bd21126ddc3bdd.jpg";